export default __webpack_public_path__ + "static/media/gpsWired_feature2.140eda53.svg";